import React, { useEffect } from 'react'
import withServices from '../../hocs/withServices'
import { Button, Container, makeStyles, Step, StepLabel, Stepper, Typography } from '@material-ui/core'
import useFetchData from '../../hooks/useFetchData';
import DormitorySelect from './components/dorm-contract/DormitorySelect';
import PaymentCheckUpload from './components/dorm-contract/PaymentCheckUpload';
import ContractSign from './components/dorm-contract/ContractSign';
import ContractData from './components/dorm-contract/ContractData';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

const getSteps = () => {
    return ['Выбор общежития и комнаты', 'Оплата проживания', 'Заполнение данных для договора', 'Подпись договора'];
}

const DormContract = ({ services }) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const contractData = React.useCallback(() => services.dormContract.getAllForAbitur(), [services.dormContract]);
    const { data: contract, fetchData: fetchContract } = useFetchData(contractData, true);

    const dormitoriesData = React.useCallback(() => services.dormContract.getDormitories(), [services.dormContract]);
    const { data: dormitories } = useFetchData(dormitoriesData, true);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    useEffect(() => {
        if (contract) {
            if (contract.dormitoryRoomId) {
                setActiveStep(1);
            }
            if (contract.paymentCheckId) {
                setActiveStep(2);
            }
            if (contract.fileId) {
                setActiveStep(3);
            }
        }
    }, [contract]);

    const getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return (
                    <DormitorySelect contract={contract} dormitories={dormitories} fetchContract={fetchContract} />
                );
            case 1:
                return (
                    <PaymentCheckUpload contract={contract} fetchContract={fetchContract} />
                );
            case 2:
                return (
                    <ContractData contract={contract} fetchContract={fetchContract} />
                );
            case 3:
                return (
                    <ContractSign contract={contract} dormitories={dormitories} fetchContract={fetchContract} />
                )
            default:
                return 'Unknown stepIndex';
        }
    }

    const checkStep = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return !contract?.dormitoryRoomId;
            case 1:
                return !contract?.paymentCheckId;
            case 2:
                return !contract?.fileId || !contract?.contractData;
            case 3:
                return !contract?.podpishiDocHash || !contract?.podpishiDocNum;
            default:
                return false;
        }
    }


    return (
        <Container component="main" className={classes.root} maxWidth="xl">
            <Typography variant="h5">Процесс принятия в общежитие</Typography>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div>
                {activeStep === steps.length ? (
                    <div>
                        <Typography className={classes.instructions}></Typography>
                    </div>
                ) : (
                    <div>
                        <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                        <div>
                            <Button
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                className={classes.backButton}
                            >
                                Назад
                            </Button>
                            {activeStep === steps.length - 1 ?
                                <></> :
                                <Button variant="contained" color="primary" disabled={checkStep(activeStep)} onClick={handleNext}>
                                    Далее
                                </Button>
                            }
                        </div>
                    </div>
                )}
            </div>
        </Container>
    )
}

export default withServices()(DormContract)